import { GetProposalQuery, ProposalLineItemIdInput } from '@/gql/graphql';

import {
  isProposalLineItemId,
  produceProposalGroupChildren,
} from './proposalSectionTree';

/**
 * Removes the targeted line item wherever it is nested. Totals are left untouched
 * — the proposal invalidation on success reconciles them.
 */
export const applyProposalLineItemDeletion = (
  data: GetProposalQuery,
  input: ProposalLineItemIdInput
): GetProposalQuery =>
  produceProposalGroupChildren(data, (children) => {
    const index = children.findIndex(
      (child) =>
        child.__typename === 'ProposalGroupLineItem' &&
        isProposalLineItemId(child.proposalLineItem, input.proposalLineItemId)
    );
    if (index !== -1) children.splice(index, 1);
  });
